import styled from "styled-components/macro";

const Wrapper = styled.div`
  &.ticker {
    width: 100%;
  }

  .current-price {
    color: #333333;
    font-family: "Legacy Serif ITC Pro";
    font-size: 20px;
    line-height: normal;
    font-weight: 500;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    text-transform: uppercase;

    text-align: center;

    margin: 0;
    padding-right: 10px;
  }

  .price {
    display: flex;
    flex: 100% 1 0;
    align-items: center;
    justify-content: center;

    margin-bottom: 5px;

    #upload-20 {
      display: none;

      height: 10px;
      width: 10px;

      &.up {
        display: block;
        transform: rotate(45deg);
      }

      &.down {
        display: block;
        transform: rotate(135deg);
      }
    }
  }

  .info {
    display: flex;
    justify-content: center;
    color: #333333;
  }

  .info p {
    display: flex;
    align-self: center;

    font-family: "Legacy Serif ITC Pro";
    font-size: 16px;
    font-weight: 500;
    line-height: normal;

    margin: 0;
  }

  .devider {
    height: 16px;
    width: 1px;
    margin: 0 8px;
    background-color: #adaeaf;
  }

  @media screen and (min-width: 640px) {
    .price #upload-20 {
      height: 20px;
      width: 20px;
    }

    .current-price {
      font-size: 32px;
    }

    .info p {
      font-size: 26px;
    }

    .devider {
      height: 26px;
    }
  }

  @media screen and (min-width: 993px) {
    .current-price {
      font-size: 38px;
    }

    .info p {
      font-size: 18px;
    }

    .devider {
      height: 18px;
    }
  }

  @media screen and (min-width: 1241px) {
    .current-price {
      font-size: 56px;
    }

    .info p {
      font-size: 26px;
      padding-top: 3px;
    }

    .devider {
      height: 31px;
    }
  }
`;

export default function Ticker(props) {
  const {
    currency = "CHF",
    symbol = "SLHN",
    currentPrice = 0,
    change = 0,
    percentageChange = 0,
    arrow = "up",
  } = props;

  return (
    <Wrapper className="ticker">
      <div className="content">
        <div className="price">
          <h2 className="current-price">{`${currency} ${currentPrice}`}</h2>
          <svg id="upload-20" className={arrow} viewBox="0 0 20 20">
            <path
              d="M3.6 6.9l.4.3c.2.2.5.2.7 0l4.6-4.6v16.8c0 .3.2.5.5.5h.5c.3 0 .5-.2.5-.5V2.7l4.6 4.6c.2.2.5.2.7 0l.4-.4c.2-.2.2-.5 0-.7l-4.9-4.9-.7-.7-.4-.4c-.3-.2-.7-.2-.9-.1l-.3.4-.7.7-5 5c-.2.2-.2.5 0 .7z"
              id="icons"
            />
          </svg>
        </div>
        <div className="info">
          <p>{`${symbol} ${currency} ${change}`}</p>
          <div className="devider" />
          <p>{`${percentageChange}%`}</p>
        </div>
      </div>
    </Wrapper>
  );
}
